import React, { useState } from 'react';
import { ButtonStyled, IconButtonStyled } from '../../asset/styled/component/ButtonStyled';

import wastebasketIcon from '../../asset/img/previous_wastebasket_icon.svg';
import addIcon from '../../asset/img/common/add_icon.svg';

import pencilIcon from '../../asset/img/common/pencil_icon.svg';

const Button = ({
  value,
  style,
  size = 'medium',
  color = 'primary',
  variant = 'contained',
  disabled = false,
  imgSrc,
  imgHoverSrc,
  imgLoc = 'left',
  onClick,
  imgStyle = {},
  addButton = false,
  className,
  fullWidth = false,
  deleteButton = false,
  alt = '',
}) => {
  // variant : contained(background) / sub(outline) / text
  // color : primary / secondary / tertiary
  // size : large / medium / small / XSmall

  const [hovered, setHovered] = useState(false);

  /*
    프로젝트마다 primary color가 다르다.
    buttonStyled이 아닌 designSystem.css 가서 primary 컬러를 프로젝트에 맞게 바꿔서 사용할 것..
  */

  return (
    <ButtonStyled
      {...{ variant, color, size, disabled, imgLoc, style, className, fullWidth }}
      onClick={!disabled ? onClick : () => {}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      {value}
      {addButton && <img src={addIcon} alt={`${value}`} />}
      {deleteButton && <img src={wastebasketIcon} style={imgStyle} alt={`${value}`} />}
      {imgSrc != undefined && (
        <img
          src={hovered ? (imgHoverSrc != undefined ? imgHoverSrc : imgSrc) : imgSrc}
          style={imgStyle}
          alt={alt}
        />
      )}
    </ButtonStyled>
  );
};

export default Button;

export const IconButton = ({
  value,
  style,
  size = 'medium',
  color = 'primary',
  variant = 'contained',
  disabled = false,
  imgSrc,
  imgHoverSrc,
  imgLoc = 'left',
  onClick,
  imgStyle = {},
  className,
  deleteIcon = false,
  addIcon = false,
  alt = '',
}) => {
  return (
    <IconButtonStyled {...{ variant, color, size, disabled, imgLoc, style, className, onClick }}>
      {imgSrc != undefined && <img src={imgSrc} alt={alt} />}
      {deleteIcon && <img src={wastebasketIcon} alt={alt} />}
      {addIcon && <img src={pencilIcon} alt={alt} />}
    </IconButtonStyled>
  );
};
